import { useState } from 'react';
import { captureAndTranscribe } from './util/speech_utils';
import { openCommandPanel, closeCommandPanel } from './ui/CommandPanel';
import { CookieManager } from './CookieManager';
import BMapsTooltip from './ui/BMapsTooltip';
import { applyWordsAsCommands } from './cmds/cmds_helpers';

const GREETING_COOKIE = 'disableGreeting';

export default function VoiceCommandListener() {
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [recording, setRecording] = useState(false);

    async function captureAndSend() {
        setRecording(true);
        const recorder = await captureAndTranscribe({
            setMediaRecorder,
            handleTranscription: applyWordsAsCommands,
            autoTranscribe: true,
        });

        // first time using recorder
        if (!mediaRecorder) {
            const disableGreeting = CookieManager.exists(GREETING_COOKIE)
                && !!CookieManager.get(GREETING_COOKIE);
            if (!disableGreeting) {
                SayGreeting();
            }
        }

        setMediaRecorder(recorder);
    }

    async function stopRecording() {
        setRecording(false);
        mediaRecorder.stop();
    }

    async function SayGreeting() {
        const greeting = `
        Greetings! Welcome to B Maps.
        While this microphone is active, you can speak to me to perform commands.
        Everything I hear will be sent to the voice to text provider, but nothing is saved.
        Click the microphone again, and I'll stop listening.
        `;
        await sayMessage(greeting);
    }

    const microphoneTitle = recording
        ? 'BMaps is listening for voice commands. Click to disable.'
        : 'The microphone is off. Click to start listening for voice commands.';
    const buttonStyle = recording ? { color: 'green' } : {};
    const microphoneIcon = recording ? 'fa fa-microphone' : 'fa fa-microphone-slash';
    return (
        <div>
            <BMapsTooltip title={microphoneTitle} useColorScheme placement="bottom">
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (recording) {
                            stopRecording();
                            closeCommandPanel();
                        } else {
                            captureAndSend();
                            openCommandPanel();
                        }
                    }}
                    id="speech_button"
                    className="topbar-button topbar-button-with-label no-tooltipster"
                    style={buttonStyle}
                >
                    <i className={microphoneIcon} />
                    <div className="topbar-button-label">Voice</div>
                </button>
            </BMapsTooltip>
        </div>
    );
}

/**
 * @param {string} message
 */
export async function sayMessage(message) {
    return new Promise((resolveGreeting) => {
        const getVoices = () => new Promise((resolveVoices) => {
            let voices = speechSynthesis.getVoices();
            if (voices.length) {
                resolveVoices(voices);
                return;
            }
            speechSynthesis.onvoiceschanged = () => {
                voices = speechSynthesis.getVoices();
                speechSynthesis.onvoiceschanged = null;
                resolveVoices(voices);
            };
        });

        getVoices().then((voices) => {
            const greeting = new SpeechSynthesisUtterance(message);
            greeting.volume = 1;
            let foundVoice = false;
            for (const voice of voices) {
                if (!foundVoice && (voice.name === 'Fiona' || voice.name === 'Google UK English Female')) {
                    greeting.voice = voice;
                    foundVoice = true;
                }
            }
            greeting.onend = () => {
                resolveGreeting();
            };
            speechSynthesis.speak(greeting);
        });
    });
}
